import { apiSlice } from './apiSlice';
import { useAppSelector } from '@/redux/hooks';

export interface BusinessTime {
  companyId: string; enabled: boolean; businessNow: string; businessDate: string;
  localDatetime: string; realNow: string; timezone: string; revision: string | null;
  changedAt: string | null; canManage: boolean;
}
export const businessClockApi = apiSlice.injectEndpoints({ endpoints: builder => ({
  businessClock: builder.query<BusinessTime, string>({
    query: companyId => ({ url: '/business-clock', params: { expectedCompanyId: companyId } }),
    transformResponse: (response: { data: BusinessTime }) => response.data,
  }),
  changeBusinessClock: builder.mutation<BusinessTime, { companyId: string; enabled: boolean; at: string | null; revision: string | null; password: string }>({
    query: ({ companyId, ...data }) => ({ url: '/business-clock', method: 'PUT', data: { ...data, expectedCompanyId: companyId } }),
    transformResponse: (response: { data: BusinessTime }) => response.data,
  }),
}) });
export const { useBusinessClockQuery, useChangeBusinessClockMutation } = businessClockApi;

export function useBusinessTime() {
  const companyId = useAppSelector(state => state.auth?.tenantId ?? state.tenant?.tenantId);
  const result = useBusinessClockQuery(companyId ?? '', { skip: !companyId, pollingInterval: 30000, skipPollingIfUnfocused: true, refetchOnFocus: true, refetchOnMountOrArgChange: true });
  return { ...result, companyId, data: !result.error && result.currentData?.companyId === companyId ? result.currentData : undefined };
}
